import { useState } from 'react';
import ModalBtn from '../../molecules/modalButton/view';
import Table from '../../molecules/tablas/view';
import { BsViewList } from 'react-icons/bs';
import './style.css';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { getNoteDocumentItems } from '../../../usecases/notes-usecase';
import { IoReload } from 'react-icons/io5';
import { BiCheckCircle, BiTrendingUp, BiTrendingDown } from 'react-icons/bi';
import { formatMoney } from '../../../utils/formating';
import ProductInfo from '../ProductInfo/view';

const ListItemsNote = ({ data, profile }) => {
    const [details, setDetails] = useState(null);

    function handleOpen() {
        setDetails(null);
        getNoteDocumentItems(profile.uid, profile.cid, data.note_id).then((res) => {
            setDetails(res);
        }).catch(() => {
            dispatchCustomEvent("popup", { message: "Error al cargar el detalle de la nota", type: "error" });
        });
    }

    const isInput = data.total_amount > 0;

    return (
        <ModalBtn
            id={"note-" + data.note_id}
            title={<BsViewList />}
            onClick={handleOpen}
            width="80vw"
            type="action"
        >
            {details ? (
                <div className='list-notes-detail-box'>
                    <div className="comprobante-body-grid">
                        <div className="comprobante-general-info">
                            <div className="info-field-group">
                                <span className="info-label">Documento</span>
                                <span className="info-value">Ajuste de Inventario #{data.note_id}</span>
                            </div>
                            <div className="info-field-group">
                                <span className="info-label">Descripción</span>
                                <span className="info-value">{data.description || 'Sin descripción'}</span>
                            </div>
                            <div className="info-subgrid">
                                <div className="info-field-group">
                                    <span className="info-label">Fecha Registro</span>
                                    <span className="info-value">{new Date(data.created_at).toLocaleDateString()}</span>
                                </div>
                                <div className="info-field-group">
                                    <span className="info-label">Total Ítems</span>
                                    <span className="info-value">{data.total_items}</span>
                                </div>
                            </div>
                        </div>

                        <div className={`balance-card-modern ${isInput ? 'balanced' : 'unbalanced'}`}>
                            <div className="card-header-status">
                                <span className="status-badge" style={{ color: isInput ? '#27ae60' : '#e74c3c' }}>
                                    {isInput ? <BiTrendingUp /> : <BiTrendingDown />}
                                    TIPO: {isInput ? 'ENTRADA' : 'SALIDA'}
                                </span>
                                <span className="resumen-label">RESUMEN AGREGADO</span>
                            </div>
                            <div className="card-totals-grid">
                                <div className="total-col">
                                    <span className="total-label-modern">Valor Total Ajustado</span>
                                    <span className="total-amount-modern" style={{ color: isInput ? '#27ae60' : '#e74c3c' }}>
                                        {formatMoney(Math.abs(details.reduce((acc, item) => acc + (item.value * item.amount), 0)))}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="comprobante-lines-section">
                        <div className="lines-header-row">
                            <h3 className="lines-title-modern">DETALLE DE MOVIMIENTOS</h3>
                        </div>
                        <Table
                            id={"items-note-" + data.note_id}
                            data={details.map(item => ({
                                product_id: item.products_id,
                                amount: item.amount,
                                value: item.value,
                                total: item.value * item.amount,
                                description: item.description,
                                product: item.product
                            }))}
                            maxHeight="40vh"
                            headersList={["PRODUCTO", "CANTIDAD", "VALOR UNIT.", "SUBTOTAL", "COMENTARIO"]}
                            excludeList={["id", "product"]}
                            formats={{
                                product_id: {
                                    type: "custom",
                                    children: <ProductInfo />
                                },
                                value: { type: "money" },
                                total: { type: "money" }
                            }}
                        />
                    </div>
                </div>
            ) : (
                <div className="loading-container" style={{ padding: '80px', textAlign: 'center', opacity: 0.6 }}>
                    <IoReload className="spin" style={{ fontSize: '2.5rem', marginBottom: '15px' }} />
                    <p>Cargando detalle de ajuste...</p>
                </div>
            )}
        </ModalBtn>
    );
};

export default ListItemsNote;
